import { inject, Injectable } from "@angular/core";
import { BaseWorkflowStateService } from "../base-workflow-state.service";
import { WirelessFlowType, WirelessSetupData } from "../../../../../../models/order/workflow/wireless/wireless-flow.model";
import { WirelessFlowStateService } from "./wireless-flow-state.service";
@Injectable({ providedIn: 'root' })
export class WirelessSetupStateService extends BaseWorkflowStateService<WirelessSetupData> {
    private flowStateService = inject(WirelessFlowStateService);
    override stateKey: string = 'wirelessSetup';

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ wirelessSetup: this.state() });
    }

    wirelessFlowType(): WirelessFlowType | undefined {
        const flowData = this.state();
        return flowData?.selectedCustomerCode as WirelessFlowType;
    }

    isExistingCustomerFlow(): boolean {
        const flowData = this.state();
        return flowData?.selectedCustomerCode === WirelessFlowType.EXISTING;
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }


}